var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-collapse',_vm._l((_vm.policy),function(item,index){return _c('el-collapse-item',{key:index,staticStyle:{"word-break":"keep-all"},attrs:{"title":item.name ?? '',"name":item.catalog_id ?? ''}},[_c('div',{staticClass:"table-ck",staticStyle:{"word-break":"keep-all"},domProps:{"innerHTML":_vm._s(item.content)}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }